module.exports = __webpack_public_path__ + "static-v-shop/1765543028354/img/data-fiscal.a3ed015d.png";